import { Directive, HostBinding, Input, signal } from "@angular/core";

// Helper types
type SpacingSizes = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;
type SpacingValues =
	| "p"
	| "py"
	| "px"
	| "pt"
	| "pb"
	| "pl"
	| "pr"
	| "m"
	| "my"
	| "mx"
	| "mt"
	| "mb"
	| "ml"
	| "mr";
type FlexValues =
	| "none"
	| "flex"
	| "flex-wrap"
	| "flex-row"
	| "flex-column"
	| "flex-column-reverse"
	| "justify-content-end"
	| "justify-content-start"
	| "justify-content-center"
	| "justify-content-between"
	| "justify-content-around"
	| "align-items-end"
	| "align-items-start"
	| "align-items-center"
	| "align-items-stretch"
	| "flex-grow";
type MatTextClasses = "mat-body-strong" | "mat-h1" | "mat-h2" | "mat-caption";
type SizeClasses =
	| "height-full"
	| "width-full"
	| "max-width-300"
	| "max-width-500"
	| "max-width-700";
type MatSizeClasses = "cdk-visually-hidden";
type AlignmentHelperClasses = "ml-auto" | "mr-auto" | "mx-auto";
type MediumClassPrefix = "md_";
type SmallClassPrefix = "sm_";

// Used Types
type TextClasses =
	| "text-center"
	| "text-left"
	| "text-right"
	| "text-primary"
	| "text-gray"
	| "text-bold"
	| MatTextClasses;
type SpacingClasses =
	| SizeClasses
	| MatSizeClasses
	| `${SpacingValues}-${SpacingSizes}`;
type AlignmentClasses =
	| FlexValues
	| `gap-${SpacingSizes}`
	| AlignmentHelperClasses;
type SpacingClassesMd = `${MediumClassPrefix}${SpacingClasses}`;
type AlignmentClassesMd = `${MediumClassPrefix}${AlignmentClasses}`;
type AlignmentClassesSm = `${SmallClassPrefix}${AlignmentClasses}`;

@Directive({
	selector:
		"[ppfText], [ppfSpacing], [ppfAlignment], [ppfSpacingMd], [ppfAlignmentMd], [ppfAlignmentSm], [pbText], [pbSpacing], [pbAlignment], [pbSpacingMd], [pbAlignmentMd], [pbAlignmentSm]",
	standalone: true,
})
export class PbStylingDirective {
	_classes = signal<string>("");
	@HostBinding("class") get class() {
		return this._classes();
	}
	// ppf Prefix
	@Input("ppfText") set ppftext(textClasses: TextClasses[]) {
		this._classes.set(`${this._classes()} ${textClasses.join(" ")}`);
	}
	@Input("ppfSpacing") set ppfspacing(spacingClasses: SpacingClasses[]) {
		this._classes.set(`${this._classes()} ${spacingClasses.join(" ")}`);
	}
	@Input("ppfSpacingMd") set ppfspacingMd(
		spacingClasses: SpacingClassesMd[],
	) {
		this._classes.set(`${this._classes()} ${spacingClasses.join(" ")}`);
	}
	@Input("ppfAlignment") set ppfflex(alignmentClasses: AlignmentClasses[]) {
		this._classes.set(`${this._classes()} ${alignmentClasses.join(" ")}`);
	}
	@Input("ppfAlignmentMd") set ppfflexMd(
		alignmentClasses: AlignmentClassesMd[],
	) {
		this._classes.set(`${this._classes()} ${alignmentClasses.join(" ")}`);
	}
	@Input("ppfAlignmentSm") set ppfflexSm(
		alignmentClasses: AlignmentClassesSm[],
	) {
		this._classes.set(`${this._classes()} ${alignmentClasses.join(" ")}`);
	}
	// pb Prefix
	@Input("pbText") set text(textClasses: TextClasses[]) {
		this._classes.set(`${this._classes()} ${textClasses.join(" ")}`);
	}
	@Input("pbSpacing") set spacing(spacingClasses: SpacingClasses[]) {
		this._classes.set(`${this._classes()} ${spacingClasses.join(" ")}`);
	}
	@Input("pbSpacingMd") set spacingMd(spacingClasses: SpacingClassesMd[]) {
		this._classes.set(`${this._classes()} ${spacingClasses.join(" ")}`);
	}
	@Input("pbAlignment") set flex(alignmentClasses: AlignmentClasses[]) {
		this._classes.set(`${this._classes()} ${alignmentClasses.join(" ")}`);
	}
	@Input("pbAlignmentMd") set flexMd(alignmentClasses: AlignmentClassesMd[]) {
		this._classes.set(`${this._classes()} ${alignmentClasses.join(" ")}`);
	}
	@Input("pbAlignmentSm") set flexSm(alignmentClasses: AlignmentClassesSm[]) {
		this._classes.set(`${this._classes()} ${alignmentClasses.join(" ")}`);
	}
}
